// extracted by mini-css-extract-plugin
export default {"link":"NoPermission_link__qmP45","container":"NoPermission_container__lCMQP"};